import { Component, Inject } from '@angular/core';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';
import { CONFIRMATION_MODAL_DATA } from '@core/customCDK/cdkCustomMdl/tokens/confirmation-data.token';
import { CommonModule } from '@angular/common';
import {
  ConfirmationModalConfig,
  ConfirmationModalService,
} from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { UniversalFormComponent } from '../universal-form/universal-form.component';
import { CdkCustomMdlModule } from '@core/customCDK/cdkCustomMdl/cdk-custom-mdl.module';
import { CategoryService } from './helper/category.service';
import { DynamicFormService } from '../universal-form/helper/dynamic-form.service';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketingService } from '../helper/ticketing.service';
import { RequestType } from '../helper/ticket.interface';
@Component({
  selector: 'app-category',
  standalone: true,
  imports: [CommonModule, CdkCustomMdlModule],
  templateUrl: './category.component.html',
  styleUrl: './category.component.scss',
})
export class CategoryComponent {
  category: RequestType[] = [];
  selectedCategoryIndex: number | null = null;
  selectedCategory: RequestType;
  showCancelButton = false; // Default to Back button

  constructor(
    private _ConfirmationModalService: ConfirmationModalService,
    public dialogRef: ConfirmationModalOverlayRef,
    @Inject(CONFIRMATION_MODAL_DATA) public data: any,
    private _CategoryService: CategoryService,
    private _formService: DynamicFormService,
    private _TicketingService: TicketingService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.category = this._CategoryService.requestType as any;

    // Debug logs to check incoming data

    // Determine button type - check both possible sources
    this.showCancelButton = data?.source || false;

  }

  onCategoryClick(item: RequestType): void {

    this.selectedCategoryIndex = item.id;
    // Get the component to open
    this.selectedCategory = item;
  }
  back() {
    this.dialogRef.close();

    if (!this.showCancelButton) {
      this._TicketingService.openSupportTypes();
    } else {
      this._CategoryService.requestType = null;
    }
  }
  createUniverslForm() {
    this._TicketingService.updateRaiseTicketData = {
      request_type_id: this.selectedCategory.id,
    };

    this.dialogRef.close();
    const reqBody = {
      form_id: this.selectedCategory?.form_id
    }
    this._formService.getDynamicForm(reqBody).subscribe((res: any) => {
      if (res.code == 200) {
        const a = [
          {
            label: 'Select Issue Type',
            fieldname: 'other_issue_type',
            type: 'radio',
            required: 'Y',
            minlength: null,
            maxlength: null,
            accept_fileupload: '0',
            placeholder: 'Select issue type',
            sample: null,
            fillable_form: null,
            options: [
              {
                name: 'Reports requirement',
                value: '0',
              },
              {
                name: 'Suggestion for Improvement',
                value: '1',
              },
            ],
          },
          {
            label: '',
            fieldname: 'description',
            type: 'textarea',
            required: 'Y',
            minlength: null,
            maxlength: null,
            accept_fileupload: '0',
            placeholder: 'Write a brief description of your request',
            sample: null,
            fillable_form: null,
            options: null,
          },
          {
            label: 'Upload Document',
            fieldname: 'upload',
            type: 'file',
            required: '0',
            minlength: null,
            maxlength: null,
            accept_fileupload: 'N',
            placeholder: 'File size must be less than 5MB',
            sample: null,
            fillable_form: null,
            options: null,
          },
          {
            label: 'CC Email Address (optional)',
            fieldname: 'email',
            type: 'text',
            required: 'N',
            minlength: null,
            maxlength: null,
            accept_fileupload: 'N',
            placeholder: 'CC Email Address (optional)',
            sample: null,
            fillable_form: null,
            options: null,
          },
        ];
        // res.form = a;
        this._ConfirmationModalService.init(UniversalFormComponent, {
          data: {
            data: res.form,
            value: this.selectedCategory,
          },
        });
      } else {
        const customConfig: ConfirmationModalConfig = {
          data: {
            icon: 'error',
            msg: res?.message,
            // btnConfirm: 'Okay',
            btnClose: 'Okay',
            allowOutsideClick: false,
            allowEscapeKey: false,
          },
        };
        this._ConfirmationModalService
          .init(ConfirmationComponent, customConfig)
          .subscribe((events: any) => {
            events.initRef.close();
          });
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
